import {
  COOKIE_NAME,
  COOKIE_KEY_RECOMMENDED,
  DEFAULT_REPOSITORY,
  COOKIE_DAYS,
} from '../constants'
import type { RuralyticsRecommendedRepository } from '../entities/RuralyticsRecommendedRepository'
import { browserFetch as browserFetchCottagesStatsNew } from '~~/modules/api/rurality/v3/cottages/stats/new'

export const useRuralyticsComposable = () => {
  const route = useRoute()
  const { getCookieRurality, setCookieRurality } = useCookiesRurality()

  const hasRecommendedParamInUrl = (): boolean => {
    const getUrlParam = (param: string) => route.query[param]
    const recommendedParam = getUrlParam('recommended')
    return recommendedParam === 'true'
  }

  const getRepository = () => {
    const cookieInstance: RuralyticsRecommendedRepository =
      getCookieRurality(COOKIE_NAME)

    if (
      cookieInstance &&
      Array.isArray(cookieInstance[COOKIE_KEY_RECOMMENDED])
    ) {
      return cookieInstance
    } else {
      return DEFAULT_REPOSITORY
    }
  }

  const cottageIsInRepository = (id: string): boolean => {
    const repository = getRepository()
    return repository[COOKIE_KEY_RECOMMENDED].includes(id)
  }

  const setIdInRepository = (id: string) => {
    const repository = getRepository()
    repository[COOKIE_KEY_RECOMMENDED].push(id)
    setRepositoryCookie(repository)
  }

  const setRepositoryCookie = (repository: RuralyticsRecommendedRepository) => {
    setCookieRurality(repository, COOKIE_NAME, COOKIE_DAYS)
  }

  const fetchEndpointClick = async (id: string) => {
    const data = await browserFetchCottagesStatsNew({
      cottageId: id,
      event: 'click',
    })

    if (data.success) {
      setIdInRepository(id)
    }
  }

  const sendClickedRecommended = (id: string) => {
    if (hasRecommendedParamInUrl() && !cottageIsInRepository(id)) {
      fetchEndpointClick(id)
    }
  }

  return {
    sendClickedRecommended,
  }
}
